export const ADD_EMPLOYEE_STARTED = 'ADD_EMPLOYEE_STARTED';
export const ADD_EMPLOYEE_COMPLETED = 'ADD_EMPLOYEE_COMPLETED';
export const ADD_EMPLOYEE_ERROR = 'ADD_EMPLOYEE_ERROR';

export const EDIT_EMPLOYEE_STARTED = 'EDIT_EMPLOYEE_STARTED';
export const EDIT_EMPLOYEE_COMPLETED = 'EDIT_EMPLOYEE_COMPLETED';
export const EDIT_EMPLOYEE_ERROR = 'EDIT_EMPLOYEE_ERROR';

export const FETCH_EMPLOYEES_STARTED = 'FETCH_EMPLOYEES_STARTED';
export const FETCH_EMPLOYEES_COMPLETED = 'FETCH_EMPLOYEES_COMPLETED';
export const FETCH_EMPLOYEES_ERROR = 'FETCH_EMPLOYEES_ERROR';

export const DELETE_EMPLOYEE_STARTED = 'DELETE_EMPLOYEE_STARTED';
export const DELETE_EMPLOYEE_COMPLETED = 'DELETE_EMPLOYEE_COMPLETED';
export const DELETE_EMPLOYEE_ERROR = 'DELETE_EMPLOYEE_ERROR';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/employeeActionTypes.js